import { toast } from "react-toastify";
import { all, put, takeLatest } from "redux-saga/effects";

// Apis
import { getRoadStretchesData } from "../../../apis/OrgRoadStretchAPI";

// Constants and utils
import { RoadStretch } from "../../../constants/action-constants/RoadStretchActionConstants";
import { getErrorMessage } from "../../../utils/util";

function getMediaTransformedStretches(roadStretches = []) {
  // if no stretches present
  if (!roadStretches || roadStretches.length < 1) {
    return [];
  }

  // transform
  const mediaTransformedStretches = roadStretches.map((stretch) => {
    const { orgMedias = [] } = stretch;

    const transformedOrgMedias = orgMedias.map((media) => {
      const {
        cityId,
        id,
        mediaId,
        height,
        width,
        isDigital,
        litStatus,
        latitude,
        longitude,
        fileItems,
        mediaGroup,
        mediaTag,
        roadStretchId,
        roadStretchName,
        routeType,
        source,
        sourceId,
        title,
        type,
        userId,
      } = media;
      return {
        cityId,
        id,
        mediaId,
        height,
        width,
        isDigital,
        litStatus,
        latitude,
        longitude,
        fileItems,
        mediaGroup,
        mediaTag,
        roadStretchId,
        roadStretchName,
        routeType,
        source,
        sourceId,
        title,
        type,
        userId,
      };
    });

    return {
      ...stretch,
      orgMedias: transformedOrgMedias,
    };
  });

  return mediaTransformedStretches;
}

export function* getCityRoadStretches(action) {
  const {
    cityId,
    isArchived,
    isDigitalMedias,
    arterialRoutes,
    mediaTypes,
    zones,
    freqOptLocations,
    setSelectedTab, // option key for closing tab
    isStoreCityAllStretchesCount, // for storing original response stretches count for city (1st time)
    isMediaTransform = false,
  } = action.payload;

  try {
    let roadStretches = [];

    // api response for "road-stretches"
    roadStretches = yield getRoadStretchesData(
      cityId,
      isArchived,
      isDigitalMedias,
      arterialRoutes,
      mediaTypes,
      zones,
      freqOptLocations
    );

    // transform media response
    if (isMediaTransform) {
      roadStretches = getMediaTransformedStretches(roadStretches);
    }

    yield put({
      type: RoadStretch.GET_CITY_ROAD_STRETCHES_SUCCESS,
      payload: { roadStretches, isStoreCityAllStretchesCount },
    });

    // conditionally closing OpenedTab by setting "index => 0"
    if (setSelectedTab) {
      setSelectedTab(0);
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    yield put({
      type: RoadStretch.GET_CITY_ROAD_STRETCHES_FAILURE,
      payload: error,
    });
    toast.error(errorMessage);
  }
}

export default function* root() {
  yield all([
    takeLatest(RoadStretch.GET_CITY_ROAD_STRETCHES, getCityRoadStretches),
  ]);
}
